"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORDER_EVENT_MAP = void 0;
exports.ORDER_EVENT_MAP = {
    ORDER_INITIATE: 'InitiateOrderEvent',
    ORDER_ITEM_ADD: 'AddOrderItemEvent',
    ORDER_ITEM_ADD_COMBO: 'AddComboEvent',
    ORDER_ASSIGN_TABLE: 'AssignTableEvent',
    ORDER_ASSIGN_TABLES: 'AssignTablesEvent',
    ORDER_SAVE: 'SaveOrderEvent',
    ORDER_ASSIGN_ORDER_TYPE: 'AssignOrderTypeEvent',
    ORDER_UPDATE_ORDER_NOTES: 'UpdateOrderNotesEvent',
    ORDER_UPDATE_FULFILMENT_DETAIL: 'UpdateFulfilmentDetail',
    ORDER_ASSIGN_CUSTOMER: 'AssignCustomerEvent',
    ORDER_UPDATE_CUSTOMER: 'UpdateCustomerEvent',
    ORDER_UNASSIGN_CUSTOMER: 'UnassignCustomerEvent',
    ORDER_UNASSIGN_TABLE: 'UnassignTableEvent',
    ORDER_PAYMENT: 'OrderPaymentEvent',
    ORDER_PAYMENT_PROCESSED: 'OrderPaymentProcessedEvent',
    ORDER_UPDATE_TIP: 'UpdateTipEvent',
    ORDER_ADD_TIP: 'AddTipEvent',
    ORDER_VOID: 'VoidOrderEvent',
    ORDER_REFUND: 'InitiateRefundEvent',
    ORDER_ITEM_REMOVE: 'RemoveOrderItemEvent',
    ORDER_ITEM_UPDATE_PRICE: 'UpdateOrderItemPriceEvent',
    ORDER_ITEM_UPDATE_QUANTITY: 'UpdateOrderItemQuantityEvent',
    ORDER_ADD_DISCOUNT: 'AddOrderDiscountEvent',
    ORDER_ASSIGN_RESERVATION: 'AssignReservationEvent',
    ORDER_UNASSIGN_RESERVATION: 'UnassignReservationEvent',
    ORDER_ITEM_ADD_MODIFIER: 'AddModifierEvent',
    ORDER_ITEM_REMOVE_MODIFIER: 'RemoveModifierEvent',
    ORDER_ITEM_UPDATE_MODIFIER_QUANTITY: 'UpdateModifierQuantityEvent',
    ORDER_ITEM_ADD_NOTES: 'AddOrderItemNotesEvent',
    ORDER_REFUND_INITIATE: 'InitiateRefundEvent',
    ORDER_REFUND_ITEMS: 'RefundOrderItemsEvent',
    ORDER_REFUND_AMOUNT: 'RefundOrderAmountEvent',
    ORDER_ASSIGN_REFUND_REASON: 'AssignRefundReasonEvent',
    ORDER_REFUND_UPDATE: 'OrderRefundUpdateEvent',
    ORDERS_REFETCH: 'OrdersRefetchEvent',
    ORDER_ADD_ADJUSTMENT: 'AddOrderAdjustmentEvent',
    ORDER_UPDATE_ADJUSTMENTS: 'UpdateOrderAdjustmentsEvent',
    ORDER_ITEMS_UPDATE_ADJUSTMENT: 'UpdateOrderItemsAdjustmentEvent',
    ORDER_REMOVE_ADJUSTMENTS: 'RemoveOrderAdjustmentEvent',
    ORDER_HOLD_ITEM: 'HoldOrderItemEvent',
    ORDER_HOLD: 'HoldOrderEvent',
    REMOVE_ORDER_HOLD: 'RemoveHoldOrderEvent',
    ORDER_FIRE_ITEMS: 'FireOrderItemsEvent',
    ORDER_PRINT_KITCHEN_DOCKET: 'PrintKitchenDocketEvent',
    ORDER_UPDATE_SEAT_NUMBER: 'UpdateSeatNumberEvent',
    ORDER_INITIATE_ONLINE: 'InitiateOnlineOrderEvent',
    ORDER_ACCEPT: 'AcceptOrderEvent',
    ORDER_REJECT: 'RejectOrderEvent',
    ORDER_PARTNER_CANCEL: 'PartnerCancelOrderEvent',
    ORDER_COMPLETE: 'CompleteOrderEvent',
    ORDER_SWITCH_COURSE_ITEM: 'SwitchCourseItemEvent',
    ORDER_UPDATE_LAST_CHECK: 'UpdateOrderLastCheckEvent',
    ORDER_PRINT: 'PrintOrderEvent',
    ORDER_PLACED: 'OrderPlacedEvent',
    ORDER_INITIATE_MERGE: 'OrderInitiateMergeEvent',
    ORDER_MERGED: 'OrderMergedEvent',
    ORDER_CLOSE: 'OrderCloseEvent',
    ORDER_OPEN: 'OrderOpenEvent',
    ORDER_REWARD_ADD: 'AddRewardItemEvent',
    ORDER_REWARD_REMOVE: 'RemoveRewardItemEvent',
    ORDER_REWARD_UPDATE_QUANTITY: 'UpdateRewardItemEvent',
    ORDER_REWARD_RESET: 'ResetRewardItemEvent',
    ORDER_REWARD_ADD_SNAPSHOT: 'AddOrderLoyaltySnapshotEvent',
    ORDER_ASSIGN_NAME: 'AssignOrderNameEvent',
    CUSTOMER_NOTIFICATION: 'CustomerNotificationEvent',
    ORDER_ITEM_SPLIT_QUANTITY: 'SplitQuantityOrderItemEvent',
    ORDER_SET_ALLERGENS: 'AssignOrderAllergensEvent',
    ORDER_TRANSFER_ITEMS: 'OrderTransferItemsEvent',
    ORDER_TRANSFERRED_ITEMS: 'OrderTransferredItemsEvent',
    ORDER_TRANSFER_TABLES: 'OrderTransferTablesEvent',
    ORDER_LOCK: 'OrderLockEvent',
    ORDER_UNLOCK: 'OrderUnLockEvent',
};
//# sourceMappingURL=events.js.map